import { ChangeEvent } from 'react'
import { Field } from './styles'

interface RadioInputProps {
    option: string
    id: string
    isChecked: boolean
    value?: string | number
    name?: string
    isDisabled?: boolean
    onChange?: (value: ChangeEvent<HTMLInputElement>) => void
    ariaLabelledBy?: string
}

const RadioInput = ({
    option,
    id,
    isChecked,
    isDisabled,
    onChange,
    value,
    name,
    ariaLabelledBy,
}: RadioInputProps) => (
    <Field
        type="radio"
        id={id}
        name={name || option}
        value={value}
        isChecked={isChecked}
        readOnly
        isDisabled={isDisabled}
        onChange={onChange}
        ariaLabelledBy={ariaLabelledBy}
    ></Field>
)

export default RadioInput
